import Header from './components/Header';
import Hero from './components/Hero';
import FaqSection from './components/FaqSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FaqSection />
        <TopicsSection />
        <MediaSection />
        <AppSection />
        <ContactSection />
        <IndexSection />
        <UpdatesSection />
        <FeaturesSection />
        <RankingSection />
        <CommentsSection />
        <CardsSection />
        <AboutSection />
        <CarouselSection />
      </main>
      <Footer />
    </>
  );
}